import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "btn"]

  validate() {
    const digits = this.inputTarget.value.replace(/\D/g, "")
    this.btnTarget.disabled = digits.length < 11
  }
}
